import React from 'react';
import { LegacyDismissAction } from './legacy-dismiss-action.js';
var LegacyWrappedCardContainer = function LegacyWrappedCardContainer(_ref) {
  var cardProps = _ref.cardProps,
    cardEffects = _ref.cardEffects;
  var containerClass = cardProps.containerClass,
    dismissable = cardProps.dismissable,
    onDismiss = cardProps.onDismiss,
    children = cardProps.children;
  var mediaRight = cardEffects.mediaRight;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-main-container ".concat(mediaRight ? 'media-right' : '', " ").concat(containerClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: "presentation-card-content"
  }, /*#__PURE__*/React.createElement(LegacyDismissAction, {
    dismissable: dismissable,
    onDismiss: onDismiss
  }), children));
};
LegacyWrappedCardContainer.displayName = "LegacyWrappedCardContainer";
export { LegacyWrappedCardContainer };